module.exports = __webpack_public_path__ + "static/media/down.546b6757.svg";